module.exports = __webpack_public_path__ + "static/media/falconHeavy.2ad3bb38.png";